
<script>
import moment from 'moment'
import 'moment/locale/es';
/**
 * tableReports component
 */
export default {
	props: {
		tableReports: {
			type: Array,
			default: function () {
				return [];
			},
		},
		itemsTable: {
			type: Array,
			default: function () {
				return [];
			},
		},
	},
	data() {
		return {
			showModal: false,
			dialog: false,
			dialogDelete: false,
		};
	},

 computed: {
		formTitle () {
			return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
		},
	},

	filters: {
		moment: function (date) {
			return moment(date).format('LL');
		}
	},


	watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
        this.initialize()
    },

	methods: {
		moment: function (date) {
			return moment(date).format('LL');
		},
		date: function (date) {
			return moment(date).format('LL');
		},
		sortTable(n) {
		var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
		table = document.getElementById("myTable2");
		switching = true;
		// Set the sorting direction to ascending:
		dir = "asc";
		/* Make a loop that will continue until
		no switching has been done: */
		while (switching) {
			// Start by saying: no switching is done:
			switching = false;
			rows = table.rows;
			/* Loop through all table rows (except the
			first, which contains table headers): */
			for (i = 1; i < (rows.length - 1); i++) {
				// Start by saying there should be no switching:
				shouldSwitch = false;
				/* Get the two elements you want to compare,
				one from current row and one from the next: */
				x = rows[i].getElementsByTagName("TD")[n];
				y = rows[i + 1].getElementsByTagName("TD")[n];
				/* Check if the two rows should switch place,
				based on the direction, asc or desc: */
				if (dir == "asc") {
					if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
						// If so, mark as a switch and break the loop:
						shouldSwitch = true;
						break;
					}
				} else if (dir == "desc") {
					if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
						// If so, mark as a switch and break the loop:
						shouldSwitch = true;
						break;
					}
				}
			}
			if (shouldSwitch) {
				/* If a switch has been marked, make the switch
				and mark that a switch has been done: */
				rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
				switching = true;
				// Each time a switch is done, increase this count by 1:
				switchcount ++;
			} else {
				/* If no switching has been done AND the direction is "asc",
				set the direction to "desc" and run the while loop again. */
				if (switchcount == 0 && dir == "asc") {
					dir = "desc";
					switching = true;
				}
			}
		}
	}

},

	editItem (item) {
		this.editedIndex = this.desserts.indexOf(item)
		this.editedItem = Object.assign({}, item)
		this.dialog = true
	},

	deleteItem (item) {
		this.editedIndex = this.desserts.indexOf(item)
		this.editedItem = Object.assign({}, item)
		this.dialogDelete = true
	},

	deleteItemConfirm () {
		this.desserts.splice(this.editedIndex, 1)
		this.closeDelete()
	},

	close () {
		this.dialog = false
		this.$nextTick(() => {
			this.editedItem = Object.assign({}, this.defaultItem)
			this.editedIndex = -1
		})
	},

	closeDelete () {
		this.dialogDelete = false
		this.$nextTick(() => {
			this.editedItem = Object.assign({}, this.defaultItem)
			this.editedIndex = -1
		})
	},

	save () {
		if (this.editedIndex > -1) {
			Object.assign(this.desserts[this.editedIndex], this.editedItem)
		} else {
			this.desserts.push(this.editedItem)
		}
		this.close()
	},

}
</script>

<template>
	<div class="table-responsive mb-0">
		<table class="table table-centered table-nowrap align-middle" id="myTable2">
			<thead class="table-light">
				<tr>
					<th v-for="item in itemsTable" :key="item.index" class="align-middle"> <button class="botontabla" v-on:click="sortTable(item.index)">{{item.label}}</button> </th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="data in tableReports" :key="data.index">
					<td v-for="val in itemsTable" :key="val.index">
						{{
							val.val === 'fecha' ||
							val.val === 'fecha_registro' ||
							val.val === 'fecha_creacion' ||
							val.val === 'fecha_nacimiento' ||
							val.val === 'fecha_venta' ||
							val.val === 'fecha_entrega' ?
							data[val.val] ? moment(data[val.val]) : '' :
							val.val === 'total_venta' ||
							val.val === 'ahorro_venta' ||
							val.val === 'precio_regular' ||
							val.val === 'total_descuento' ? 
							`$ ${data[val.val]}`:
							val.val === 'apellidos' ?
							`${data['apellido_paterno']} ${data['apellido_materno']}` :
							val.val === 'nombre_completo' ?
							`${data['nombre']} ${data['apellido_paterno']} ${data['apellido_materno']}` :
							data[val.val]
						}}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<!-- end table -->
</template>

<style>

.botontabla{
		background: none;
		color: inherit;
		border: none;
		padding: 0;
		font: inherit;
		cursor: pointer;
		outline: inherit;}

</style>
